module.exports = __webpack_public_path__ + "img/sushiHubLogo.11cb04eb.svg";